import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell, ResponsiveContainer } from 'recharts';

export function ScoreDistributionChart({ data }) {
  const hasData = data.some(d => d.count > 0);
  if (!hasData) {
    return <div className="text-sm text-slate-400 py-8 text-center">Noch keine ausgewerteten Ergebnisse im Zeitraum.</div>;
  }
  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={data} margin={{ top: 8, right: 8, bottom: 8, left: -16 }}>
        <XAxis dataKey="label" tick={{ fontSize: 11 }} />
        <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
        <Tooltip formatter={(v) => [`${v} Ergebnisse`, 'Anzahl']} labelFormatter={(l) => `Score ${l}`} />
        <Bar dataKey="count" radius={[4, 4, 0, 0]}>
          {data.map((entry, i) => <Cell key={i} fill={entry.color} />)}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
